<template>
  <div class="field-group">
    <label class="field-label required">
      Palavras-chave
      <span
        class="help-icon"
        title="Adicione palavras-chave"
        >?</span
      >
    </label>

    <div class="keywords-input">
      <input
        v-model="palavra"
        type="text"
        class="field-input keyword-field"
        placeholder="Digite uma palavra-chave e pressione Enter"
        @keydown.enter.prevent="adicionarPalavra"
      />
      <button
        type="button"
        class="btn-adicionar"
        @click.prevent="adicionarPalavra"
      >
        Adicionar
      </button>
    </div>

    <div
      v-if="palavrasChave && palavrasChave.length > 0"
      class="keywords-tags"
    >
      <h6>Palavras selecionadas:</h6>
      <span
        v-for="(item, index) in palavrasChave"
        :key="index"
        class="keyword-tag"
      >
        {{ item }}
        <button
          type="button"
          class="tag-remove"
          title="Remover palavra-chave"
          @click.prevent="removerPalavra(index)"
        >
          ×
        </button>
      </span>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, ref } from "vue";

const palavra = ref("");
const palavrasChave = defineModel({ default: () => [] });

function adicionarPalavra() {
  const termo = palavra.value.trim();

  if (!Array.isArray(palavrasChave.value)) {
    palavrasChave.value = [];
  }

  if (termo === "") {
    alert("A palavra-chave não pode ser vazia");
    return;
  }

  const novasPalavras = termo
    .split(/[;,]+/)
    .map((p) => p.trim())
    .filter((p) => p !== "" && !palavrasChave.value.includes(p));

  if (novasPalavras.length > 0) {
    palavrasChave.value.push(...novasPalavras);
    palavra.value = "";
  } else if (palavrasChave.value.includes(termo)) {
    alert("Não é permitido palavras repetidas");
  }
}

function removerPalavra(index) {
  if (Array.isArray(palavrasChave.value)) {
    palavrasChave.value.splice(index, 1);
  }
}
</script>

<style scoped>
.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--preto);
  display: flex;
  align-items: center;
  gap: 6px;
}

.field-label.required::before {
  content: "*";
  color: #5b3fa8;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9e9e9e;
  color: var(--branco);
  font-size: 0.65rem;
  font-weight: bold;
  cursor: pointer;
}

.field-input {
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 0.9rem;
  color: var(--preto);
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.field-input:focus {
  border-color: #5b3fa8;
  box-shadow: 0 0 0 2px rgba(91, 63, 168, 0.12);
}

/* Keywords */
.keywords-input {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.keyword-field {
  flex: 1;
}

.btn-adicionar {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-adicionar:hover {
  background: #4a3090;
}

.keywords-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  border: 1px solid var(--roxo-escuro1);
  border-radius: 15px;
  padding: 20px 5px 10px 10px;
}

.keywords-tags h6 {
  position: absolute;
  margin-top: -30px;
  margin-left: 5px;
  z-index: 100;
  background-color: white;
  color: var(--roxo-escuro1);
  font-size: 15px;
}

.keyword-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ede9f8;
  color: #5b3fa8;
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 0.8rem;
  font-weight: 500;
}

.tag-remove {
  background: none;
  border: none;
  color: #5b3fa8;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
}

.tag-remove:hover {
  color: #3b2078;
  font-weight: bold;
}
</style>
